import React, { createContext, useState, useContext, ReactNode } from 'react';

export type Customer = {
  id: string;
  name: string;
};

export const defaultCustomers: Customer[] = [
  { id: 'tyme-bank', name: 'Tyme Bank' },
  { id: 'fnb', name: 'FNB' },
  { id: 'discovery', name: 'Discovery' }
];

interface CustomerContextType {
  customer: Customer;
  customers: Customer[];
  setCustomer: (customer: Customer) => void;
}

const CustomerContext = createContext<CustomerContextType | undefined>(undefined);

export const CustomerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [customer, setCustomer] = useState<Customer>(defaultCustomers[0]);
  
  return (
    <CustomerContext.Provider value={{ 
      customer, 
      customers: defaultCustomers, 
      setCustomer 
    }}>
      {children}
    </CustomerContext.Provider>
  );
};

export const useCustomer = (): CustomerContextType => {
  const context = useContext(CustomerContext);
  if (context === undefined) {
    throw new Error('useCustomer must be used within a CustomerProvider');
  }
  return context;
};

